export default __webpack_public_path__ + "static/media/dashboard1.20bdbc7b.png";